export enum DropdownEnum {
  getGroupsDDL = 'PcbGroup/GroupsDDL', // 可用機台群組
  getGoods = 'PcbGoods/Goods', // 取得商品列表
  getOtherGoodsPool = 'PcbGoods/OnOtherGoodsPool', // 取得商品列表-其他業主商品池
  userRoleInStore = 'UserRole/UserRoleInStore', // 權限設定
  getStores = 'Store/Stores', // 可用店家
  getGoodsDDL = 'PcbGoods/GoodsDDL', // 商品
  setIsVisible = 'PcbGoods/SetIsVisible', // 設定商品標記/隱藏
  setIsVisibleOnOtherPool = 'PcbGoods/SetIsVisibleOnOtherPool', // 設定商品標記/隱藏-其他業主商品池
  getGoodsPoolModifiedRecords = 'PcbGoods/GoodsPoolModifiedRecords' // 取得店家商品編輯紀錄總攬
}
